import { Layout, Menu, Dropdown, Button, Grid, Card, Typography, Tooltip } from 'antd';
import {
  FileTextOutlined,
  SettingOutlined,
  ApartmentOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
const { Text } = Typography;

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const menuItems = [
  {
    key: 'certificates',
    icon: <FileTextOutlined />,
    label: <Link to="/certificates">Удостоверения</Link>,
    path: '/certificates',
  },
  {
    key: 'objects',
    icon: <ApartmentOutlined />,
    label: <Link to="/objects">Оборудование</Link>,
    path: '/objects',
  },
  {
    key: 'settings',
    icon: <SettingOutlined />,
    label: <Link to="/settings">Настройки</Link>,
    path: '/settings',
  },
];

export default function AppLayout({ children }) {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const location = useLocation();
  const navigate = useNavigate();

  const [currentKey, setCurrentKey] = useState('');

  useEffect(() => {
    const matched = menuItems.find((item) => location.pathname.startsWith(item.path));
    setCurrentKey(matched?.key || '');
  }, [location.pathname]);

  const handleMenuClick = (e) => {
    setCurrentKey(e.key);
  };

  const dropdownMenu = (
    <Menu
      selectedKeys={[currentKey]}
      items={menuItems.map(({ key, icon, label }) => ({ key, icon, label }))}
      onClick={handleMenuClick}
    />
  );

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {!isMobile && (
        <Sider width={200} theme="light" style={{ paddingTop: 16 }}>
          {/* Логотип */}
  <div
    onClick={() => navigate('/certificates')}
    style={{
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      padding: '0 16px 16px 16px',
      fontWeight: 'bold',
      fontSize: 16,
      gap: 8,
    }}
  >
    <img
      src="https://tmg-din.ru/img/logo.svg"
      alt="logo"
      style={{
        width: 36,
        height: 36,
        filter: 'invert(31%) sepia(99%) saturate(7496%) hue-rotate(203deg) brightness(96%) contrast(101%)',
      }}
    />
    <Text>
        Реестр
    </Text>
  </div>


          {/* Меню */}
          <Menu
            mode="inline"
            selectedKeys={[currentKey]}
            items={menuItems.map(({ key, icon, label }) => ({
              key,
              icon,
              label,
            }))}
            onClick={handleMenuClick}
            style={{ borderRight: 0 }}
          />
        </Sider>
      )}

      <Layout>
        {isMobile && (
          <Header
            style={{
              background: '#fff',
              padding: '0 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Dropdown overlay={dropdownMenu} trigger={['click']}>
              <Button type="text" icon={menuItems.find(i => i.key === currentKey)?.icon}>
                {menuItems.find((i) => i.key === currentKey)?.label}
                <DownOutlined style={{ marginLeft: 8 }} />
              </Button>
            </Dropdown>
          </Header>
        )}

        <Content style={{ padding: 6, backgroundColor: 'white' }}>
          {isMobile?
            children
            :
            <Card>{children}</Card>
          }        
        </Content>
      </Layout>
    </Layout>
  );
}
